export enum ERequestState {
  Pending = 'pending',
  Done = 'done',
  Error = 'error'
}
